(function () {
    'use strict';

    angular
        .module('app.createCustomReport', [])
        .controller('createCustomReportCtrl', ['$scope', '$modal', '$modalInstance', 'createCustomReportService', 'TRACK_EVENTS',
            function ($scope, $modal, $modalInstance, createCustomReportService, TRACK_EVENTS) {

            	$scope.selectedSection = [];

            	$scope.getSections = function() {
            		createCustomReportService.getSections(true)
            			.then(function(response) {
            				$scope.sections = response.data;
            			})
            	}

            	$scope.selectSection = function(section) {
            		$scope.isExist = false;
            		if($scope.selectedSection.length == 0) {
            			$scope.selectedSection.push({
                            section_id: section.id, 
                            section_preview_image: section.section_preview_image, 
                            position: 1
                        });
            			section.checked = true;
            		} else {
            			for(var i = $scope.selectedSection.length - 1; i >= 0; i--) {
            				if($scope.selectedSection[i].section_id == section.id) {
            					$scope.isExist = true;
            					$scope.selectedSection.splice(i, 1);
                                section.checked = false;

                                for(var j = i; j < $scope.selectedSection.length; j++) {
                                    $scope.selectedSection[j].position = $scope.selectedSection[j].position - 1;
                                }

            				}
            			}

            			if($scope.isExist == false) {
            				$scope.selectedSection.push({
                                section_id: section.id, 
                                section_preview_image: section.section_preview_image, 
                                position: $scope.selectedSection.length + 1
                            });

                            section.checked = true;
            			}
            		}
            	}

            	$scope.sectionRemove = function(section) {
            	    for(var i = $scope.selectedSection.length - 1; i >= 0; i--) {
                        if($scope.selectedSection[i].section_id == section.section_id) {
                            $scope.selectedSection.splice(i, 1);

                            for(var j = i; j < $scope.selectedSection.length; j++) {
                                $scope.selectedSection[j].position = $scope.selectedSection[j].position - 1;
                            }
                        }
                    }
                    for(var i=0; i<$scope.sections.length; i++) {
                        if($scope.sections[i].id == section.section_id) {
                            $scope.sections[i].checked = false;
                        }
                    }
            	}

            	$scope.createCustomReport = function() {
            		var params = {
                        company_id: $scope.selectedAdvertiser,
            			report_name: $scope.customReportName,
            			sections: $scope.selectedSection
            		}

            		createCustomReportService.createCustomReport(params, true)
            			.then(function(response) {
                            // Mixpanel tracking create report
                            analytics.track(
                                TRACK_EVENTS.CREATE_REPORT.EVT_NAME,
                                {
                                    "action": "Create",
                                    "item": TRACK_EVENTS.CREATE_REPORT.ITEM_NAME,
                                    "report_name": params.report_name,
                                    "params": params
                                }
                            );
            				$scope.closeModal();
                            $scope.sendHttpRequest();
            			}, function(response) {
            				var errorModalInstance = $modal.open({
			                    scope: $scope,
			                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
			                    windowClass: 'modal-dialog-mention-error'
			                });
			                $scope.errorModalInstance = errorModalInstance;
			                $scope.errorMessage = response.message;
            			})
            	}

            	$scope.closeModal = function() {
            		$modalInstance.close();
            	}

                $scope.sectionUp = function(index) {
                    if (index <= 0 || index >= $scope.selectedSection.length)
                        return;
                    var temp = $scope.selectedSection[index];
                    $scope.selectedSection[index] = $scope.selectedSection[index - 1];
                    $scope.selectedSection[index - 1] = temp;
                    $scope.selectedSection[index].position = $scope.selectedSection[index].position + 1;
                    $scope.selectedSection[index - 1].position = $scope.selectedSection[index].position - 1;
                    
                };

                $scope.sectionDown = function(index) {
                    if (index < 0 || index >= ($scope.selectedSection.length - 1))
                        return;
                    var temp = $scope.selectedSection[index];
                    $scope.selectedSection[index] = $scope.selectedSection[index + 1];
                    $scope.selectedSection[index + 1] = temp;
                    $scope.selectedSection[index].position = $scope.selectedSection[index].position - 1;
                    $scope.selectedSection[index + 1].position = $scope.selectedSection[index].position + 1;
                };
                
            	$scope.getSections();
            }
        ])

})();